module.exports = __webpack_public_path__ + "static/img/yy.b49882d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/theme1/common/yy.png
// module id = QqWr
// module chunks = 319